import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render making money exercise section for FAQ Page
 */
const MakingMoneyExercise = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="making-money-exercise-section-component"
    >
      <AccordionV2
        testId="making-money-exercise"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Is the Singapore Corporate Awards a money-making exercise?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>It certainly is not.</p>

          <p>
            First, the time and cost of the award nominations, judging and
            selection process are provided by the organisers and their award
            partners.
          </p>

          <p>
            The cost is primarily in the conduct of the gala evening which is a
            grand but costly affair with the staging and setting befitting the
            occasion. The cost of the gala dinner is partially covered by a
            sponsor with corporations paying for their own tables. The
            organisers seek to just breakeven each year.
          </p>

          <p>
            In addition, the three co-organisers (ISCA, SID, BT) have signed an
            agreement where each undertakes that there will be no financial
            benefit accruing to any of the individual organisations from
            organising the event. Instead, any surplus in any year will be
            ploughed back into the next year&apos;s gala dinner. However, when
            the surplus becomes significant, the organisers have agreed to spend
            it on an event related to the awards.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default MakingMoneyExercise;
